import type { PlanetEventTag as PlanetEventTagData } from "@/shared/contracts";
import { Chip } from "./primitives";

/**
 * “星球活动：{活动名}”小标签（世界运营第二期 2a D9，看板 #11，2026-09-27）。
 * 动态（Post）、收藏（CollectionItem）、手账页（TravelJournal）那一趟的车费由星球活动补助时，后端给 planet_event {event_id, title}。
 * - 活动名只用后端给的（活动结束、取消了也照给）；没有（null）或名字是空的，整条不显示，不编名字；
 * - 标签跟着内容走，不改变谁能看见：内容在哪儿出现，标签就在哪儿出现；
 * - 用现有的小标签 Chip（中性色，纸卡上自动换纸墨色），不自创样式；是普通文字，读屏照读“星球活动：xxx”；
 * - “星球活动：”和活动名的第一个字粘在一起，不会在冒号后面断行；活动名太长时后面照常折行，不溢出。
 */
export function planetEventTitle(event: PlanetEventTagData | null | undefined): string | null {
  const title = event?.title?.trim();
  return title ? title : null;
}

/** 标签本身（放进已有的一排小标签里用它）。没有活动名时什么都不画。 */
export function PlanetEventTag({ event }: { event: PlanetEventTagData | null | undefined }) {
  const title = planetEventTitle(event);
  if (!title) return null;
  const [first, ...rest] = Array.from(title);
  return (
    <Chip data-planet-event={event?.event_id}>
      <span className="ps-planet-event">
        <span className="ps-planet-event__head">星球活动：{first}</span>
        {rest.join("")}
      </span>
    </Chip>
  );
}

/** 单独占一行的标签（放在一段文字下面用它）：上下各留一点空，不被父级拉宽。没有活动名时整行都不画。 */
export function PlanetEventLine({ event }: { event: PlanetEventTagData | null | undefined }) {
  if (!planetEventTitle(event)) return null;
  return (
    <span className="ps-planet-event-line">
      <PlanetEventTag event={event} />
    </span>
  );
}
